import React from 'react'
import './services.css'
import { BiCheck } from 'react-icons/bi'

const Services = () => {
    return (
        <section id='services'>
            <h5>What I Offer</h5>
            <h2>Services</h2>

            <div className="container services__container">
                <article className="service">
                    <div className="service__head">
                        <h3>UI/UX</h3>
                    </div>
                    <ul className='service__list'>

                        <li>
                            <BiCheck cl className='service__list-icon' />
                            <p>Lorem ipsum dolor sit amet elit.</p>
                        </li>
                        <li>
                            <BiCheck cl className='service__list-icon' />
                            <p>Lorem ipsum dolor sit amet elit.</p>
                        </li>
                        <li>
                            <BiCheck cl className='service__list-icon' />
                            <p>Lorem ipsum dolor sit amet elit.</p>
                        </li>
                        <li>
                            <BiCheck cl className='service__list-icon' />
                            <p>Lorem ipsum dolor sit amet elit.</p>
                        </li>
                        <li>
                            <BiCheck cl className='service__list-icon' />
                            <p>Lorem ipsum dolor sit amet elit.</p>
                        </li>
                    </ul>
                </article>
                {/* End of UI/UX */}

                <article className="service">
                    <div className="service__head">
                        <h3>Web Development</h3>
                    </div>
                    <ul className='service__list'>

                        <li>
                            <BiCheck cl className='service__list-icon' />
                            <p>Lorem ipsum dolor sit amet elit.</p>
                        </li>
                        <li>
                            <BiCheck cl className='service__list-icon' />
                            <p>Lorem ipsum dolor sit amet elit.</p>
                        </li>
                        <li>
                            <BiCheck cl className='service__list-icon' />
                            <p>Lorem ipsum dolor sit amet elit.</p>
                        </li>
                        <li>
                            <BiCheck cl className='service__list-icon' />
                            <p>Lorem ipsum dolor sit amet elit.</p>
                        </li>
                        <li>
                            <BiCheck cl className='service__list-icon' />
                            <p>Lorem ipsum dolor sit amet elit.</p>
                        </li>
                        <li>
                            <BiCheck cl className='service__list-icon' />
                            <p>Lorem ipsum dolor sit amet elit.</p>
                        </li>
                        <li>
                            <BiCheck cl className='service__list-icon' />
                            <p>Lorem ipsum dolor sit amet elit.</p>
                        </li>
                    </ul>
                </article>
                {/* End of Content Creation*/}
                <article className="service">
                    <div className="service__head">
                        <h3>Content Creation</h3>
                    </div>
                    <ul className='service__list'>

                        <li>
                            <BiCheck cl className='service__list-icon' />
                            <p>Lorem ipsum dolor sit amet elit.</p>
                        </li>
                        <li>
                            <BiCheck cl className='service__list-icon' />
                            <p>Lorem ipsum dolor sit amet elit.</p>
                        </li>
                        <li>
                            <BiCheck cl className='service__list-icon' />
                            <p>Lorem ipsum dolor sit amet elit.</p>
                        </li>
                        <li>
                            <BiCheck cl className='service__list-icon' />
                            <p>Lorem ipsum dolor sit amet elit.</p>
                        </li>
                        <li>
                            <BiCheck cl className='service__list-icon' />
                            <p>Lorem ipsum dolor sit amet elit.</p>
                        </li>
                    </ul>
                </article>
                {/* End of UI/UX */}
            </div>
        </section>
    )
}

export default Services